import React from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  ListGroup,
  ProgressBar,
  Form,
  ListGroupItem,
  Accordion,
} from "react-bootstrap";

const ContactCase3 = ({
  handleBack1,
  Handleform2,
  activeKey,
  setActiveKey,
  handleChange,
  Specification,
  uploadPrescriptionHandler,
}) => {
  const handleAccordionSelect = (key) => {
    setActiveKey(key);

    // Reset form values when switching between options
    if (key === "upload") {
      // Set all manual form values to 0
      handleChange("od_sph", 0);
      handleChange("od_cyl", 0);
      handleChange("od_axis", 0);
      handleChange("os_sph", 0);
      handleChange("os_cyl", 0);
      handleChange("os_axis", 0);
      handleChange("pd_type", "None");
      handleChange("pd_value", 0);
      handleChange("prescriptionImage", "");
      if (Specification.prescriptionType === "Multi-focal") {
        handleChange("Add_Power", 0);
      }
    } else if (key === "zero") {
      // Set all values to 0 for zero prescription
      handleChange("od_sph", 0);
      handleChange("od_cyl", 0);
      handleChange("od_axis", 0);
      handleChange("os_sph", 0);
      handleChange("os_cyl", 0);
      handleChange("os_axis", 0);
      handleChange("pd_type", "None");
      handleChange("pd_value", 0);
      handleChange("prescriptionImage", "");
      if (Specification.prescriptionType === "Multi-focal") {
        handleChange("Add_Power", 0);
      }
    } else if (key === "manual") {
      // Clear uploaded prescription
      handleChange("prescriptionImage", "");
    }
  };

  const validateForm = (e) => {
    const errors = {};

    if (Object.keys(errors).length > 0) {
      e.preventDefault();

      return;
    }

    Handleform2(e);
  };

  const handleZeroPrescription = (e) => {
    e.preventDefault();
    // Form validation happens in validateForm, so we can just call Handleform2
    Handleform2(e);
  };
  return (
    <Col
      className='shadow'
      md={8}
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <ProgressBar className=' Fpro shadow' variant='info' animated now={66} />

      <Modal.Header closeButton>
        <Button
          onClick={handleBack1}
          size='sm'
          className='btn-light Psbutton shadow'
        >
          <i className='fa fa-arrow-left' aria-hidden='true'></i>
        </Button>
      </Modal.Header>

      <Modal.Title className='text-center'>
        Help Us With Your Details
      </Modal.Title>
      <Modal.Body>
        <Accordion activeKey={activeKey} onSelect={handleAccordionSelect}>
          <Accordion.Item
            eventKey='manual'
            style={{ border: "1px solid silver" }}
          >
            <Accordion.Header>Enter Prescription Manually</Accordion.Header>
            <Accordion.Body>
              <Form onSubmit={validateForm}>
                <ListGroup variant='flush'>
                  <ListGroupItem>
                    <Form.Label as='legend'>OD (Right Eye)</Form.Label>
                    <Row>
                      <Form.Group as={Col} xs='4'>
                        SPH
                        <Form.Select
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("od_sph", e.target.value)
                          }
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(40)].map((_, i) => {
                            const value = -9.5 + i * 0.5;
                            return (
                              <option key={value} value={value}>
                                {value.toFixed(1)}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} xs='4'>
                        CYL{" "}
                        <Form.Select
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("od_cyl", e.target.value)
                          }
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(40).keys()].map((x) => {
                            const value = -9.5 + x * 0.5; // Calculate the value

                            if (value % 1 === 0) {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            } else {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            }
                          })}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} xs='4'>
                        AXIS (in Degrees)
                        <Form.Select
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("od_axis", e.target.value)
                          }
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(36).keys()].map((x) => {
                            const value = 5 + x * 5;

                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                  </ListGroupItem>

                  <ListGroupItem>
                    <Form.Label as='legend'>OS (Left Eye)</Form.Label>
                    <Row>
                      <Form.Group as={Col} xs='4'>
                        SPH
                        <Form.Select
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("os_sph", e.target.value)
                          }
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(40).keys()].map((x) => {
                            const value = -9.5 + x * 0.5; // Calculate the value

                            if (value % 1 === 0) {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            } else {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            }
                          })}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} xs='4'>
                        CYL{" "}
                        <Form.Select
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("os_cyl", e.target.value)
                          }
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(40).keys()].map((x) => {
                            const value = -9.5 + x * 0.5; // Calculate the value

                            if (value % 1 === 0) {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            } else {
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            }
                          })}
                        </Form.Select>
                      </Form.Group>
                      <Form.Group as={Col} xs='4'>
                        AXIS (in Degrees)
                        <Form.Select
                          size='sm'
                          as='select'
                          onChange={(e) =>
                            handleChange("os_axis", e.target.value)
                          }
                          required={activeKey === "manual"}
                          disabled={activeKey !== "manual"}
                        >
                          <option value='' hidden>
                            Select
                          </option>
                          {[...Array(36).keys()].map((x) => {
                            const value = 5 + x * 5;

                            return (
                              <option key={value} value={value}>
                                {value}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Row>
                  </ListGroupItem>
                  {Specification.prescriptionType === "Multi-focal" && (
                    <ListGroupItem>
                      <Form.Label as='legend'>Add Power (+)</Form.Label>
                      <Row>
                        <Form.Group as={Col} xs='4'>
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("Add_Power", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey !== "manual"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[
                              0.0, 0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0,
                              2.25, 2.5, 2.75, 3.0,
                            ].map((value) => (
                              <option key={value} value={value.toFixed(2)}>
                                {value.toFixed(2)}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Row>
                    </ListGroupItem>
                  )}

                  <ListGroupItem className='d-flex justify-content-center'>
                    <Button
                      className='Psbutton shadow btn-light rounded mt-3'
                      type='submit'
                    >
                      Save Changes and Continue
                    </Button>
                  </ListGroupItem>
                </ListGroup>
              </Form>
            </Accordion.Body>
          </Accordion.Item>

          <div className='position-relative my-3'>
            <hr
              className='position-absolute w-100 top-50'
              style={{ margin: 0 }}
            />
            <div className='d-flex justify-content-center'>
              <span
                className='bg-white px-3 text-muted'
                style={{ position: "relative", zIndex: 1 }}
              >
                OR
              </span>
            </div>
          </div>

          <Accordion.Item
            eventKey='upload'
            style={{ border: "1px solid silver" }}
          >
            <Accordion.Header>Upload Prescription Document</Accordion.Header>
            <Accordion.Body>
              <Form.Group>
                <Form.Label>
                  Upload Your Prescription (Accepted formats: JPG, JPEG, PNG,
                  PDF)
                </Form.Label>
                <Form.Control
                  type='file'
                  id='uploadedPrescription'
                  accept='.jpg, .jpeg, .png, .pdf'
                  onChange={uploadPrescriptionHandler}
                  required={activeKey === "upload"}
                />
              </Form.Group>
              <Button
                className='Psbutton shadow btn-light rounded mt-3'
                onClick={Handleform2}
              >
                Save Changes and Continue
              </Button>
            </Accordion.Body>
          </Accordion.Item>
          <div className='position-relative my-3'>
            <hr
              className='position-absolute w-100 top-50'
              style={{ margin: 0 }}
            />
            <div className='d-flex justify-content-center'>
              <span
                className='bg-white px-3 text-muted'
                style={{ position: "relative", zIndex: 1 }}
              >
                OR
              </span>
            </div>
          </div>
          <Accordion.Item
            eventKey='zero'
            style={{ border: "1px solid silver" }}
          >
            <Accordion.Header>Zero Prescription (Plano)</Accordion.Header>
            <Accordion.Body>
              <Form onSubmit={handleZeroPrescription}>
                <ListGroup variant='flush'>
                  <ListGroupItem>
                    <Form.Check
                      type='checkbox'
                      id='zeroPrescriptionCheck'
                      label='I need zero prescription (plano) lenses'
                      checked={activeKey === "zero"}
                      onChange={() => {
                        if (activeKey !== "zero") {
                          setActiveKey("zero");
                        }
                      }}
                    />
                    <small className='text-muted d-block mt-2'>
                      Select this option if you need non-prescription lenses
                      with no vision correction.
                    </small>
                  </ListGroupItem>
                  <ListGroupItem className='d-flex justify-content-center'>
                    <Button
                      className='Psbutton shadow btn-light rounded mt-3'
                      type='submit'
                    >
                      Save Changes and Continue
                    </Button>
                  </ListGroupItem>
                </ListGroup>
              </Form>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Modal.Body>
    </Col>
  );
};

export default ContactCase3;
